const SixAABStatementContent = `

Statement of expenditure for claiming deduction under section 35CC

6AAB. [Omitted by the IT (Thirty-second Amdt.) Rules, 1999, w.e.f. 19-11-1999.]
`;

export default SixAABStatementContent;